/* eslint-disable no-nested-ternary */
/*
 *  TTTech nerve-management-system
 *  Copyright(c) 2022. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import Version from '@/model/workloads/workload-version.model';

export const ICONS = {
  DOCKER: '$vuetify.icons.iconDoc',
  VM: '$vuetify.icons.iconVm',
  CODESYS: '$vuetify.icons.iconCod',
};

export const COLORS = {
  DOCKER: '#ff9a00',
  VM: '#3810f2',
  CODESYS: '#e83e8c',
};

export default class WorkloadModel {
  /**
   * Creates an instance of WorkloadModel.
   * @param {Array} data - WorkloadModel list
   * @class WorkloadModel
   * @property {string} name - Workload name
   * @property {string} type - Workload type
   * @property {string} description - Workload description
   * @property {string} created - Workload created
   * @property {string} _id - Workload id
   * @property {Array} versions - Workload versions
   * @property {string} typeIcon - Workload icon
   * @property {string} color - Color of workload icon
   * @property {boolean} deleted - Is workload deleted
   * @property {path} path - Path
   * @property {string} tenant - Tenant
   * @property {object} changedBy - changed by
   */
  constructor(data = {}) {
    this.name = data.name || '';
    this.type = data.type || '';
    this._id = data._id || data.id;
    this.description = data.description || '';
    this.versions = data.versions ? data.versions.map((v) => new Version({ version: v, type: data.type })) : [];
    this.created = data.createdBy && data.createdBy.date ? new Date(data.createdBy.date).toLocaleString('en-GB') : '';
    this.disabled = data.disabled || false;
    this.disIcon = this.disabled ? '$vuetify.icons.disable' : '$vuetify.icons.enable';
    this.typeIcon = data.type === 'docker' ? ICONS.DOCKER : data.contentSubtype === 'vm' ? ICONS.VM : ICONS.CODESYS;
    this.color = data.type === 'docker' ? COLORS.DOCKER : data.contentSubtype === 'vm' ? COLORS.VM : COLORS.CODESYS;
    this.deleted = data.deleted || false;
    this.path = data.path || '';
    this.tenant = data.tenant || '';
    this.changedBy = data.changedBy || {};
  }
}
